import { formatDateForLocaleDisplay } from './dateFormat';

export const HIDDEN_DETAIL_FIELDS = new Set([
  'password_hash',
  'totp_secret_encrypted',
  'two_factor_backup_codes_hash',
  'session_id',
]);

const TITLE_FIELD_CANDIDATES = [
  'name',
  'student_name',
  'exercise_name',
  'break_name',
  'username',
  'title',
  'label',
  'course_name',
];

export function resolveRecordTitle(record, fieldMetaByName = {}) {
  if (!record || typeof record !== 'object') return 'Record';
  for (const key of TITLE_FIELD_CANDIDATES) {
    const val = record[key];
    if (val != null && String(val).trim() !== '') return String(val).trim();
  }
  for (const key of Object.keys(record)) {
    if (HIDDEN_DETAIL_FIELDS.has(key) || key === 'id') continue;
    const meta = fieldMetaByName[key];
    const dt = String(meta?.data_type || '').toLowerCase();
    if (dt.includes('char') || dt === 'text' || dt === 'varchar') {
      const val = record[key];
      if (val != null && String(val).trim() !== '') return String(val).trim();
    }
  }
  if (record.id != null) return `Record ${record.id}`;
  return 'Record';
}

export function formatRecordFieldValue(value, fieldMeta, isUSUser = false) {
  if (value === null || value === undefined || value === '') return '—';

  const dt = String(fieldMeta?.data_type || '').toLowerCase();
  const inputType = fieldMeta?.input_type;

  if (inputType === 'boolean' || dt === 'boolean' || typeof value === 'boolean') {
    return value === true || value === 'true' || value === 't' ? 'Yes' : 'No';
  }

  if (
    inputType === 'date' ||
    inputType === 'datetime' ||
    dt.includes('timestamp') ||
    dt === 'date' ||
    (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value))
  ) {
    return formatDateForLocaleDisplay(value, isUSUser);
  }

  if (typeof value === 'object') {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  }

  return String(value);
}

export function fieldLabelFor(fieldName, fieldMetaByName) {
  const meta = fieldMetaByName[fieldName];
  if (meta?.label) return meta.label;
  return String(fieldName || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (l) => l.toUpperCase());
}

export function buildFallbackDetailFields(record, fieldMetaByName) {
  if (!record) return [];
  return Object.keys(record)
    .filter((key) => !HIDDEN_DETAIL_FIELDS.has(key))
    .map((fieldName) => ({
      type: 'field',
      fieldName,
      label: fieldLabelFor(fieldName, fieldMetaByName),
    }));
}

/** First N object fields in schema order (excludes sensitive columns). */
export function getCoreObjectFields(fieldMetaList, limit = 10) {
  if (!Array.isArray(fieldMetaList)) return [];
  return fieldMetaList
    .filter((field) => field?.field_name && !HIDDEN_DETAIL_FIELDS.has(field.field_name))
    .slice(0, limit)
    .map((field) => ({
      fieldName: field.field_name,
      label: field.label || fieldLabelFor(field.field_name, {}),
    }));
}
